import React, { useCallback, useMemo } from 'react';
import { useLingui } from '@lingui/react/macro';

import { AccordionItem } from '@rover/react-lib/src/components/lists/Accordion';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import type { CountryRegionLink } from '@rover/types/src/CountryRegionLink';

import {
  HomePageFooterAccordionCollapsed,
  HomePageFooterAccordionExpanded,
} from './analyticsEvents';
import FooterLinkList from './FooterLinkList';

export type Props = {
  countryRegionLinks: CountryRegionLink[];
  countryName: string;
  countryFlag: string;
};

const CountryRegionLinks: React.FC<Props> = ({ countryRegionLinks, countryName, countryFlag }) => {
  const { t } = useLingui();
  const eventProperties = useMemo(
    () => ({ dropDownName: `Pet care across ${countryName}` }),
    [countryName]
  );
  const handleAccordionToggle = useCallback(
    (isOpen: boolean) => {
      const EventCtor = isOpen ? HomePageFooterAccordionExpanded : HomePageFooterAccordionCollapsed;
      emitAnalyticsEvent(new EventCtor(eventProperties));
    },
    [eventProperties]
  );

  return (
    <AccordionItem
      itemHeading={
        <>
          {t`Pet care across ${countryName}`}
          <span aria-hidden="true"> {countryFlag}</span>
        </>
      }
      itemBody={
        countryRegionLinks && (
          <FooterLinkList linkList={countryRegionLinks} numColumns={[2, 3, 6]} />
        )
      }
      onToggle={handleAccordionToggle}
      testID="footer-accordion-region-links"
    />
  );
};

export default CountryRegionLinks;
